import {
  Component,
  Input,
  Output,
  ElementRef,
  EventEmitter,
  ViewChild
} from '@angular/core';


@Component({
  selector: 'biz-label-inline-edit',
  templateUrl: './label-inline-edit.component.html',
  styleUrls: [
    './label-inline-edit.component.scss'
  ]
})
export class LabelInlineEditComponent {
  @ViewChild('input')
  public inputRef: ElementRef;

  @Input()
  public className: string;

  @Input()
  public fallback: string = '';

  @Input()
  public href: string;

  @Input()
  public icon: string;

  @Input()
  public notEmpty: boolean = false;

  @Input()
  public tag: string;

  @Input()
  public type: string;

  public _value: string;
  public get value(): string {
    if (
      this._value ===
      this.fallback
    ) {
      return (
        this.edit ?
          null :
          this.fallback
      );
    }

    return this._value;
  }
  
  public _edit: boolean = false;
  public get edit(): boolean {
    return this._edit;
  }

  @Input()
  public set edit(
    edit: boolean
  ) {
    this._edit = edit;

    if (
      this.inputRef &&
      (
        this.type ===
        'date'
      ) &&
      this._edit
    ) {
      this.inputRef
          .nativeElement
          .placeholder = (
            'DD.MM.YYYY'
          );
    }
  }

  @Input()
  public set value(
    value: string
  ) {
    this._value = value;
  }

  @Output()
  public valueChange: (
    EventEmitter<string>
  ) = (
    new EventEmitter()
  );

  public get classNames() {
    return (
    `${(
        this.className ?
          this.className :
          ''
      )}${(
        this.icon ?
          ' has-icon' :
          ''
      )}${(
        this.edit ?
          ' has-edit' :
          ''
      )}${(
        this.tag ?
          ` ${this.tag}` :
          ` no-tag`
      )}`
    );
  }

  public onValue(value) {
    const valueIsEmpty = (
      !value ||
      (
        (
          value
            .length
        ) ===
        0
      )
    );

    if (
      this.notEmpty &&
      valueIsEmpty
    ) {
      this.valueChange
          .emit(
            value
          );

      return (
        this.inputRef
            .nativeElement
            .value = (
              value
            )
      );
    }

    this.valueChange
        .emit(
          value
        );
  }
}